let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7UdVV")).then(() => parcelRequire('kCK7c'));